module.exports = __webpack_public_path__ + "img/avatar.e8fbdee6.png";